module.exports = __webpack_public_path__ + "img/1478017660.9f25c315.jpg";